import React, { useEffect, useMemo, useState } from 'react';

import EnsureId from 'psims/react/pages/primary-pages/data-submissions/shared/ensure-id';
import useSubmissionLoadState from 'psims/react/pages/primary-pages/data-submissions/shared/use-submission-load-state';
import LoadingSubmission from 'psims/react/pages/primary-pages/data-submissions/shared/loading-submission';
import LoadSubmissionFailed from 'psims/react/pages/primary-pages/data-submissions/shared/load-submission-failed';
import RefinerAnnualActivityEditor from './refiner-annual-activity-editor';
import useRefinerAnnualActivityAPI, { UseRefinerAnnualActivityAPI } from './use-refiner-annual-activity-api';

interface MsoAnnualActivityRefinerProps {
    id: number;
}

const MsoAnnualActivityRefiner = (props: MsoAnnualActivityRefinerProps) => {
    const vm = useVM(props);

    switch(vm.loadState) {
        case 'error':
            return <LoadSubmissionFailed submissionName='MSO refiner' />
        case 'loaded':
            return <RefinerAnnualActivityEditor
                // TODO: should type assert apiCtrl
                apiCtrl={vm.apiCtrl as PopulatedProps<UseRefinerAnnualActivityAPI, 'submission'>}
            />;
        default:
            return <LoadingSubmission submissionName='MSO refiner' />;

    }
}

function useVM(props: MsoAnnualActivityRefinerProps) {
    const apiCtrl = useRefinerAnnualActivityAPI({id: props.id});
    const [loaded, setLoaded] = useState(false);

    const ready = useMemo(() => {
        return loaded;
    }, [loaded])

    const loadState = useSubmissionLoadState({submission: apiCtrl.submission, isDepsReady: ready, loadStatus: apiCtrl.loadStatus})

    useEffect(() => {
        if (apiCtrl.loadStatus === 'fetched') {
            setLoaded(true);
        }
    }, [apiCtrl.loadStatus]);

    return {
        apiCtrl,
        loadState: loadState as typeof loadState,
    }
}

const Page = (props: MsoAnnualActivityRefinerProps) => <EnsureId id={props.id} Component={MsoAnnualActivityRefiner} />;

export default Page;
